var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessEventsManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,10 H40 V39 H8 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,6 H17 V15 H13 Z M31,6 H35 V15 H31 Z M8,17 H40 V21 H8 Z",
    fill: "#00D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25 H22 V31 H16 Z M26,25 H32 V31 H26 Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34,31 A6,6 0,1 0,34,43 A6,6 0,1 0,34,31",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessEventsManage);
export default __webpack_public_path__ + "static/media/p4r_business_events_manage.b61c126107c9e03be87ad2836a8d83a0.svg";
export { ForwardRef as ReactComponent };